
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "lucide-react";
import { cn } from "@/lib/utils";
import { Interview } from "@/types/interview";
import { InterviewStatusBadge } from "./InterviewStatusBadge";
import { InterviewDetails } from "./InterviewDetails";
import { InterviewActions } from "./InterviewActions";

interface InterviewCardProps {
  interview: Interview;
  onAccept: (id: string) => void;
  onCancel: (id: string) => void;
  onJoin: (interview: Interview) => void;
}

export const InterviewCard = ({ 
  interview,
  onAccept,
  onCancel,
  onJoin
}: InterviewCardProps) => {
  return (
    <Card 
      className={cn(
        "card-hover glass-card bg-white/80 backdrop-blur-sm border-sky-100",
        interview.status === "cancelled" && "opacity-75"
      )}
    >
      <CardContent className="p-6">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div className="space-y-3">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gradient-to-r from-sky-500 to-emerald-500 flex items-center justify-center text-white font-semibold">
                {interview.freelancer.split(' ').map(n => n[0]).join('')}
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900">
                  {interview.freelancer}
                </h3>
                <div className="flex items-center gap-2 mt-1">
                  <InterviewStatusBadge status={interview.status} />
                  {interview.platform && (
                    <Badge variant="outline" className="border-sky-200 text-sky-700">
                      <Link className="w-3 h-3 mr-1" />
                      {interview.platform}
                    </Badge>
                  )}
                </div>
              </div>
            </div>
            
            <InterviewDetails interview={interview} />
          </div>

          <InterviewActions 
            interview={interview}
            onAccept={onAccept}
            onCancel={onCancel}
            onJoin={onJoin}
          />
        </div>
      </CardContent>
    </Card>
  );
};
